import React, { useEffect, useState } from "react";

import {
  getPendingWaitInfo,
  formatPendingWait
} from "../../utils/pendingWait";

const colors = {
  green: { border: "#16a34a", background: "#f0fdf4", text: "#166534", icon: "🟢" },
  yellow: { border: "#eab308", background: "#fefce8", text: "#854d0e", icon: "🟡" },
  red: { border: "#dc2626", background: "#fef2f2", text: "#991b1b", icon: "🔴" },
  unknown: { border: "#94a3b8", background: "#f8fafc", text: "#475569", icon: "⚪" }
};

const PendingWaitTime = ({ ticket, compact = false }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (ticket?.status !== "pending") return undefined;

    const timer = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(timer);
  }, [ticket?.status]);

  const wait = getPendingWaitInfo(ticket, now);

  if (!wait) return null;

  const theme = colors[wait.level];

  const dateLabel = wait.createdAt !== null
    ? new Date(wait.createdAt).toLocaleString("es-MX", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      })
    : "No disponible";

  const style = {
    ...(compact
      ? {
          position: "absolute",
          left: 72,
          right: 8,
          bottom: 4,
          pointerEvents: "none"
        }
      : {
          display: "block",
          marginTop: 6
        }),
    padding: "3px 6px",
    borderLeft: `3px solid ${theme.border}`,
    backgroundColor: theme.background,
    color: theme.text,
    borderRadius: 4,
    fontSize: compact ? 11 : 12,
    lineHeight: 1.35,
    overflow: "hidden"
  };

  return (
    <span style={style} title={`Recibido: ${dateLabel}`}>
      <span style={{ display: "block" }}>
        Fecha y hora: {dateLabel}
      </span>
      <span style={{ display: "block", fontWeight: 600 }}>
        {theme.icon} Tiempo en espera: {formatPendingWait(wait.minutes)}
      </span>
    </span>
  );
};

export default PendingWaitTime;
